import React from 'react';
import { motion } from 'framer-motion';
import { Cpu } from 'lucide-react';
import CTAButton from '../CTAButton';

const ITHero = ({ 
    title = "Specialized Technology Recruitment Solutions", 
    description = "Connecting top-tier engineering talent with high-growth tech companies and enterprise systems.",
    primaryCta = "Get IT Hiring Consultation",
    secondaryCta = "Build Scalable Technology Teams",
    heroImage,
    onCtaClick
}) => {
    return (
        <section 
            className="relative min-h-[85vh] bg-[#01014C] bg-cover bg-center bg-no-repeat overflow-hidden flex items-center pt-24 pb-16"
            style={heroImage ? { 
                backgroundImage: `linear-gradient(to bottom, rgba(1, 1, 60, 0.75), rgba(1, 1, 60, 0.75)), url('${heroImage}')` 
            } : {}}
        >
            {/* Animated Grid Background */}
            <div className="absolute inset-0 opacity-10" style={{ backgroundImage: 'linear-gradient(#fff 1px, transparent 1px), linear-gradient(90deg, #fff 1px, transparent 1px)', backgroundSize: '50px 50px' }} />
            <div className="absolute top-0 right-0 w-[500px] h-[500px] bg-blue-500/20 blur-[120px] rounded-full z-0 pointer-events-none" />

            <div className="container mx-auto px-6 relative z-10 py-12">
                <div className="max-w-4xl mx-auto text-center space-y-6">
                    <motion.div initial={{ opacity: 0, y: -20 }} animate={{ opacity: 1, y: 0 }} className="inline-flex items-center gap-3 text-cyan-400 font-mono text-sm tracking-widest mb-2 justify-center">
                        <Cpu size={18} className="animate-pulse" /> SPECIALIZED TECH RECRUITMENT
                    </motion.div>
                    <motion.h1 initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.2 }} className="text-3xl md:text-5xl lg:text-6xl font-bold text-white syne leading-tight mb-4">
                        {title}
                    </motion.h1>
                    <motion.p initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.4 }} className="text-blue-100/70 text-base md:text-lg lg:text-xl max-w-3xl mx-auto leading-relaxed mb-8">
                        {description}
                    </motion.p>
                    <div className="flex flex-wrap justify-center gap-4 pt-2">
                        {primaryCta && (
                            <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ delay: 0.6 }}>
                                <CTAButton 
                                    text={primaryCta}
                                    onClick={onCtaClick}
                                />
                            </motion.div>
                        )}
                        {secondaryCta && (
                            <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ delay: 0.7 }}>
                                <CTAButton 
                                    text={secondaryCta}
                                    onClick={onCtaClick}
                                    type="secondary"
                                />
                            </motion.div>
                        )}
                    </div>
                </div>
            </div>
        </section>
    );
};

export default ITHero;